import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { IconsModule } from 'src/app/shared/icons/icons.module';
import { CardComponent } from 'src/app/shared/ui-kit/card/card.component';

import { PdfViewerModalComponent } from '../../../pdf-viewer-modal/pdf-viewer-modal.component';
import { CollaboratorMetadataComponentAbstract } from '../../metadata-components/collaborator-metadata/collaborator-metadata.component.abstract';

@Component({
  selector: 'app-collaborator-metadata-v2',
  standalone: true,
  imports: [CommonModule, CardComponent, IconsModule, PdfViewerModalComponent],
  templateUrl: './collaborator-metadata-v2.component.html',
})
export class CollaboratorMetadataV2Component extends CollaboratorMetadataComponentAbstract {}
